/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import axios from 'axios';
import { Provider } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import Spinner from '../utils/Spinner';
import BillCard from './BillCard';
import CategorieMenuItem from './CategorieMenuItem';

class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      billsByCategories: [],
      billsStarred: [],
      billsLoading: true,
      billsByCategoriesLoading: true,
      disclaimer: props.disclaimer,
    };
  }

  componentDidMount() {
    this.getBills();
    this.getBillsStarred();
  }

  async getBillsStarred() {
    await axios.get('/bills/starred')
      .then((response) => {
        this.setState({
          billsStarred: response.data.bills,
          billsLoading: false,
        });
      });
  }

  async getBills() {
    await axios.get('/bills')
      .then((response) => {
        this.setState({
          billsByCategories: response.data.categories,
          billsByCategoriesLoading: false,
        });
      });
  }

  render() {
    const {
      billsLoading,
      billsByCategories,
      billsByCategoriesLoading,
      billsStarred,
    } = this.state;

    return (
      <Provider store={store}>
        <Container fluid>
          <div>
            <div className="bill-index-sidebar">
              <ul className="nav flex-column">
                <li className="nav-item-header nav-item animated fadeInLeft">Categorias</li>
                { billsByCategoriesLoading ? <Spinner /> : (
                  <CategorieMenuItem categories={billsByCategories} />
                )}
              </ul>
            </div>

            <div className="bill-index-category-row" style={{ backgroundColor: '#ddd' }}>
              {this.state.disclaimer && (
                <div className="row">
                  <div className="col-md-10 offset-md-1">
                    <div className="main-card mt-3 mb-3" style={{ bacgroundColor: "transparent !important" }}>
                      <div className="card-body">
                        <div>
                          <div className="text-center">
                            Tem uma sugestão? Envie um e-mail para <strong><a className="link-emailto" href="mailto:abrig@inteligov.com.br">abrig@inteligov.com.br</a></strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <Row>
                <Col className="mb-4" style={{ marginTop: '60px' }}>
                  <h1 className="text-center">
                    Projetos em Destaque
                  </h1>
                </Col>
              </Row>
              { billsLoading ? <Spinner /> : <BillCard bills={billsStarred} starred /> }
            </div>
            <div className="bill-index-category-row">
              { billsByCategoriesLoading ? <Spinner /> : (
                billsByCategories.map((category, index) => (
                  <BillCard bills={category.bills} category={category.category_name} key={index} />
                ))
              )}
            </div>
          </div>
        </Container>
      </Provider>
    );
  }
}

export default Index;
